<template>
  <div class="card maturityR">
    <div class="card-header bg-transparent">
      <div class="row align-items-center">
          <div class="col green">
            <h3><i class="fas fa-chart-line"></i>Offers</h3>
          </div>
          <div class="text-right">
            <a @click="navigateListPage()" class="moreinfo cursor-pointer"><i class="fas fa-chevron-circle-right"></i> More Info</a>
          </div>
      </div>
    </div>
    <div class="card-body tradesWid">
      <div class="bid mb-3"><div>Rejected Offers:</div> <span class="bgRed">{{offerStatus.rejected ?  offerStatus.rejected : 0}}</span></div>
      <div class="bid mb-3"><div>Suspended Offers:</div> <span class="bgGreen">{{offerStatus.suspended ? offerStatus.suspended : 0}}</span></div>
      <!-- <div class="bid mb-3"><div>Cancelled Offers:</div> <span class="bgRed">{{offerStatus.cancelled ? offerStatus.cancelled  : 0}}</span></div> -->
      <div class="bid mb-3"><div>Msrb Offers:</div> <span class="bgOrange">{{offerStatus.msrb ? offerStatus.msrb  : 0}}</span></div>
      <div class="bid mb-3"><div>Hold Offers:</div> <span class="bgOrange">{{offerStatus.hold ? offerStatus.hold  : 0}}</span></div>
      <!-- <div class="bid mb-3"><div>Success Offers:</div> <span class="bgGreen">{{offerStatus.success ? offerStatus.success  : 0}}</span></div> -->
      <div class="bid mb-3"><div>Live Offers:</div> <span class="bgGreen">{{offerStatus.live ? offerStatus.live  : 0}}</span></div>
      <div class="bid mb-3"><div>Static Offers:</div> <span class="bgGreen">{{offerStatus.staticOfferCount ? offerStatus.staticOfferCount  : 0}}</span></div>
    </div>
  </div> 
</template>
<script>
export default {
  name: "tradesWidget",
  props :["offerStatus"],
  data() {
    return {
      
    };
  },
  methods: {
     navigateListPage(){
      window.location.href = "/ims/ims-offering";
    }
  },
  mounted() {
   

  }
};
</script>